import { Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { usePreferencesStore } from "@/stores/usePreferencesStore";

export default function AdvancedModeLayout() {
  const appMode = usePreferencesStore((state) => state.appMode);
  const appModeHydrated = usePreferencesStore((state) => state.appModeHydrated);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!appModeHydrated || appMode === "advanced") return;

    navigate({ to: "/dashboard", replace: true }).catch(() => {});
  }, [appMode, appModeHydrated, location.pathname, navigate]);

  if (!appModeHydrated || appMode !== "advanced") return null;

  return <Outlet />;
}
